<template>
  <div class="col-md-12 column">
    <div class="modal fade" id="modal-container-475051" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
      <div id="div_layer" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png" /></button>
            <h3 class="modal-title F3-M-27" id="myModalLabel">
              乗客予約
            </h3>
          </div>
          <div class="modal-body">
            <div id="div_top">
              <table id="tb_top" style="border: 2px solid rgb(148, 148, 148);">
                <tr>
                  <td class="td_title F3-R-15 bgc8">便名</td>
                  <td class="td_test" colspan="3">{{shiftReservations.title}}</td>
                </tr>
                 <tr v-show="shiftReservations.reserveId!==''">
                  <td class="td_title F3-R-15 bgc8">予約ID</td>
                  <td class="td_test">{{ shiftReservations.reserveId }}</td>
                  <td class="td_title F3-R-15 bgc8">便ID</td>
                  <td class="td_test">{{shiftReservations.shiftId}}</td>
                </tr>
                <tr  v-show="shiftReservations.reserveId===''">
                  <td class="td_title F3-R-15 bgc8">便ID</td>
                  <td class="td_test" colspan="3">{{shiftReservations.shiftId}}</td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">フリガナ</td>
                  <td class="td_test">{{ shiftReservations.lastNameKana + shiftReservations.firstNameKana }}</td>
                  <td class="td_title F3-R-15 bgc8">ステータス</td>
                  <td class="td_test" v-text="shiftReservations.status==1?'確定':'キャンセル待ち'"></td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">乗客(代表者)</td>
                  <td class="td_test">{{ shiftReservations.lastName + shiftReservations.firstName }}</td>
                  <td class="td_title F3-R-15 bgc8">予約受付方法</td>
                  <td class="td_test" v-text="shiftReservations.reserveType==1?'電話':'アプリ'"></td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">乗車人数</td>
                  <td class="td_test">{{shiftReservations.passengerNumber}} 名</td>
                  <td class="td_title F3-R-15 bgc8">予約受付日時</td>
                  <td class="td_test">{{time.reserveTime}}</td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">利用日</td>
                  <td class="td_test" colspan="3">{{time.useTime}}</td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">乗車場所</td>
                  <td class="td_test" v-show="shiftReservations.shiftFlag==0">
                    <span v-text="shiftReservations.startPlaceType==1?'自宅':shiftReservations.startPlaceName"></span>
                  </td>
                  <td class="td_test" v-show="shiftReservations.shiftFlag==1">
                    <span v-show="shiftReservations.startPlaceType==1">自宅</span>
                    <span v-show="shiftReservations.startPlaceType==2">{{shiftReservations.name}}</span>
                    <span v-show="shiftReservations.startPlaceType==3">{{shiftReservations.startPlaceName}}</span>
                  </td>
                  <td class="td_title F3-R-15 bgc8">乗車予定時間</td>
                  <td class="td_test">{{time.startEstimateTime}}</td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">降車場所</td>
                  <td class="td_test" v-show="shiftReservations.shiftFlag==0">
                    <span v-show="shiftReservations.arrivePlaceType==1">自宅</span>
                    <span v-show="shiftReservations.arrivePlaceType==2">{{shiftReservations.name}}</span>
                    <span v-show="shiftReservations.arrivePlaceType==3">{{shiftReservations.arrivePlaceName}}</span>
                  </td>
                  <td class="td_test" v-show="shiftReservations.shiftFlag==1">
                    <span v-text="shiftReservations.arrivePlaceType==1?'自宅':shiftReservations.arrivePlaceName"></span>
                  </td>
                  <td class="td_title F3-R-15 bgc8">降車予定時間</td>
                  <td class="td_test">{{time.arriveEstimateTime}}</td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8 " style="height: 100px;">備考</td>
                  <td class="td_test tooLong" colspan="3">
                    <p>{{shiftReservations.note}}</p>
                  </td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">同乗人数</td>
                  <td class="td_test" colspan="3">{{shiftReservations.passengerNumber-1}} 名</td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">利用料金</td>
                  <td class="td_test" colspan="3">{{shiftReservations.passengerCost}}円</td>
                </tr>
              </table>
            </div>
            <div class="modal-footer">
              <button class="btn btn-default F2-M-24 T7-larginbtn" data-dismiss="modal" @click="commitServer()">確定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {DateUtil} from '@/utils/date.js'
import dialog from '@/components/Dialog'
export default {
  components: {
    'v-dialog': dialog
  },
  props: {
    shiftReservation: {},
    time: {}
  },
  computed: {
    ...mapState({
      // 需要显示的值
      shiftReservations: state => state.shiftReservation
    })
  },
  data() {
    return{
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
    }
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    goback2 () {
      this.$router.go(-2)
    },
    goback3 () {
      this.$router.go(-10)
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    commitServer () {
      let shiftReservations = Object.assign({}, this.shiftReservations)
      // 判断行归上下车的真是上车Type
      shiftReservations.startPlaceType = Number(shiftReservations.startPlaceType)
      shiftReservations.arrivePlaceType = Number(shiftReservations.arrivePlaceType)
      if (shiftReservations.startPlaceType < shiftReservations.size + 1 || shiftReservations.size === 1) {
        if (shiftReservations.size === 1 && shiftReservations.startPlaceType === 2 && shiftReservations.shiftFlag === 0) {
          shiftReservations.startPlaceType = 3
        } else if (shiftReservations.size > 1 && shiftReservations.startPlaceType !== 1) {
          shiftReservations.startPlaceType = 2
        }
        if (shiftReservations.startPlaceType !== 3) {
          shiftReservations.startPlaceName = null
          shiftReservations.startPlaceLat = null
          shiftReservations.startPlaceLng = null
        }
      } else {
        shiftReservations.startPlaceType = 3
        shiftReservations.startStationId = null
      }
      if (shiftReservations.arrivePlaceType < shiftReservations.size + 1 || shiftReservations.size === 1) {
        if (shiftReservations.size === 1 && shiftReservations.arrivePlaceType === 2 && shiftReservations.shiftFlag === 1) {
          shiftReservations.arrivePlaceType = 3
        } else if (shiftReservations.size > 1 && shiftReservations.arrivePlaceType !== 1) {
          shiftReservations.arrivePlaceType = 2
        }
        if (shiftReservations.arrivePlaceType !== 3) {
          shiftReservations.arrivePlaceName = null
          shiftReservations.arrivePlaceLat = null
          shiftReservations.arrivePlaceLng = null
        }
      } else {
        shiftReservations.arrivePlaceType = 3
        shiftReservations.arriveStationId = null
      }
      if (shiftReservations.shiftFlag === 0 && shiftReservations.startPlaceType === 1) {
        shiftReservations.startStationId = null
      } else if (shiftReservations.shiftFlag === 1 && shiftReservations.arrivePlaceType === 1) {
        shiftReservations.arriveStationId = null
      }
      this.$axios.post('shift/insertShiftReservation2', shiftReservations).then(response => {
        console.log(response)
        if (response.data.msg === '修改成功') {
          this.$axios.get('shift/selectShiftReservation2', {params: {parentReserveId: response.data.newParentReserveId, pageShiftId: this.shiftReservations.pageShiftId}})
            .then(response => {
              console.log(response)
              if(parentReserveId != null && parentReserveId !== ""){
                this.shiftReservation = response.data.shiftReservation
                this.time.reserveTime = DateUtil.yearHourMinute(this.shiftReservation.reserveTime)
                this.time.useTime = DateUtil.yearWeek(this.shiftReservation.useTime)
                this.time.startEstimateTime = DateUtil.hourMinute(this.shiftReservation.startEstimateTime)
                this.time.arriveEstimateTime = DateUtil.hourMinute(this.shiftReservation.arriveEstimateTime)
                this.shiftReservation.time = this.time
                this.shiftReservation.flag = 'edit'
                sessionStorage.setItem('shiftReservation', JSON.stringify(this.shiftReservation))
              }
              this.goback()
            })
            .catch(error => {
              this.goback2()
              console.log(error)
            })
        } else {
          this.goback()
        }
      }).catch(error => {
        console.log(error)
        if (error.data.error === 'WBE2001') {
          this.showMessage(error.data.error_description)
        }else{
          this.showMessage('予期せぬエラーが発生しました。')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-dialog {
    margin-top: 5%;
    width: 70%!important;
}
.modal-content {
    width: 100%;
}
.modal-header {
    border-bottom: 0px;
    text-align: center;
}
.modal-footer {
    margin: 0 auto;
    border-top: 0px;
}
.modal-footer .btn-default {
    width: 40%;
    margin-right: 30%;
    background: #6f6f6f;
    border-radius: 8px;
    color: #ffffff;
    font-size: 20px;
}
.T7-larginbtn {
    border-radius: 10px;
    background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
    background-color: #717171;
    border: 0;
    height: 50px;
}
#tb_top {
    width: 100%;
    border: 1px solid gray;
    border-collapse: collapse;
}
#div_top {
    width: 96%;
    margin: 0px auto;
    margin-bottom: 20px;
}
#tb_top tr td {
    text-align: left;
    height: 30px;
    line-height: 30px;
    border: 1px solid gray;
}

#tb_top .td_test {
    padding-left: 10px;
    width: 40%
}
#tb_top .td_title {
    background-color: #dcdcdc;
    width: 12%;
    height: 36px;
    text-align: center;
}
.tooLong {
  word-wrap: break-word;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/passengerReservationConfirm.vue